"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});


/**
 * scrollTop polyfill
 * https://stackoverflow.com/questions/28633221/document-body-scrolltop-firefox-returns-0-only-js
 */
var getScrollTop = function getScrollTop() {
  return window.pageYOffset || document.documentElement && document.documentElement.scrollTop || document.body && document.body.scrollTop || 0;
};
/* global window, document */

exports.default = getScrollTop;
module.exports = exports["default"];


//////////////////
// WEBPACK FOOTER
// ../mcs-lite-ui/lib/utils/getScrollTop.js
// module id = 511
// module chunks = 4